import {createContext} from 'shared/web';

type ApplicationUpdateContextValue = {
  isPatchUpdateAvailable: boolean;
  updateApp: () => Promise<unknown>;
};

export const [ApplicationUpdateProvider, useApplicationUpdate, ApplicationUpdateContext] =
  createContext<ApplicationUpdateContextValue>({name: 'ApplicationUpdateContext'});
